import { 
    ANALYTICS_ERROR, 
    ANALYTICS_LOADER, 
    GET_ANALYTICS_VIEWS 
} from "../actionType";

let initialState = {
    loading: false,
    error: null,
    analyticsViews: [],
};

export const reducer = (state = initialState, { type, payload }) => {
    switch (type) {
        case ANALYTICS_LOADER:
            return {
                ...state,
                loading: true,
                error: null,
            };
        case ANALYTICS_ERROR:
            return {
                ...state,
                loading: false,
                error: payload,
            };
        case GET_ANALYTICS_VIEWS:
            return {
                ...state,
                loading: false,
                analyticsViews: payload,
                error: null,
            };
        default:
            return state;
    }
};
